var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "900"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.isLoaded ? _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm._v(" 작품상세정보 기본값 설정 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _vm.isLoaded ? _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "max-height": "calc(90vh - 120px)",
      "overflow-y": "auto"
    }
  }, [_c('work-view-classifications', {
    model: {
      value: _vm.inputs.workClassifications,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "workClassifications", $$v);
      },
      expression: "inputs.workClassifications"
    }
  })], 1) : _vm._e(), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4"
  }, [_c('i', {
    staticClass: "subtitle-2"
  }, [_vm._v("* "), _c('b', [_vm._v("신규 작품 생성 시")]), _vm._v(" 기본으로 불러오는 데이터입니다.")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 저장하기 ")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }